// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/rem'
import './assets/index.less'
import { Button, Calendar, Swipe, SwipeItem, Icon, Tab, Tabs, Popup, Field, ActionSheet, cell, Tabbar, TabbarItem, DatetimePicker, Toast } from 'vant'

Vue.use(Button)
Vue.use(Calendar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Popup)
Vue.use(Field)
Vue.use(ActionSheet)
Vue.use(cell)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(DatetimePicker)
Vue.use(Toast)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js